var map = {
	"./general/bg-container.jpg": 29388,
	"./general/bg-login.jpg": 69450,
	"./general/default-user.png": 58122,
	"./general/logo-amatra.png": 87255,
	"./general/usericon.png": 43029,
	"./kanisius/alphonsus.png": 5525,
	"./kanisius/cc.png": 9014,
	"./kanisius/ttdJennifer.png": 87441,
	"./kokoro/bg-container.jpg": 6449,
	"./kokoro/bg-login.jpg": 87075,
	"./kokoro/kokoro.png": 92651,
	"./parent/bg-login-mob.png": 23337,
	"./parent/bg-login.png": 97636,
	"./parent/bg-parent-1.png": 25645,
	"./parent/bg-parent-13.png": 95106,
	"./parent/bg-parent-1mob.png": 19447,
	"./parent/bg-parent.png": 43739,
	"./parent/circle-load.png": 15424,
	"./parent/default.png": 50894,
	"./parent/pdf.png": 2043,
	"./parent/user-icon-r.png": 28077,
	"./parent/usericon.png": 70435,
	"./style/customTheme.scss": 5805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;